import React from 'react';
type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'soft';
type Size = 'sm' | 'md';
interface PillButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
}
const variantClasses: Record<Variant, string> = {
  primary: 'bg-primary-700 text-white shadow-[0_8px_18px_-8px_rgba(15,118,110,0.7)] hover:bg-primary-800 focus-visible:ring-primary-200 disabled:shadow-none disabled:hover:bg-primary-700',
  danger: 'bg-coral-700 text-white shadow-[0_8px_18px_-8px_rgba(194,65,47,0.7)] hover:bg-coral-800 focus-visible:ring-coral-200 disabled:shadow-none disabled:hover:bg-coral-700',
  secondary: 'border border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50 focus-visible:ring-slate-200',
  ghost: 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus-visible:ring-slate-200',
  soft: 'bg-primary-50 text-primary-800 ring-1 ring-primary-100 hover:bg-primary-100 focus-visible:ring-primary-200 disabled:hover:bg-primary-50'
};
const sizeClasses: Record<Size, string> = {
  sm: 'h-8 gap-1.5 px-3.5 text-xs',
  md: 'h-11 gap-2 px-5 text-sm'
};
export function PillButton({
  variant = 'primary',
  size = 'md',
  icon,
  iconRight,
  className = '',
  children,
  type = 'button',
  ...rest
}: PillButtonProps) {
  return <button type={type} className={`inline-flex items-center justify-center whitespace-nowrap rounded-full font-semibold transition-[background-color,border-color,box-shadow,color,transform] duration-150 ease-out-soft active:scale-[0.97] focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100 ${variantClasses[variant]} ${sizeClasses[size]} ${className}`} {...rest} data-id="element-22" data-mp="2kdnnjxe6bofj">
      {icon}
      {children}
      {iconRight}
    </button>;
}